export const module2InitialState = {
  module2: {
    name: 'Listening',
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    moduleID: '',
    StudentID: '',
    keys: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      MonkeybarsBlue: false,
      MonkeybarsYellow: false,
      SlideYellow: false,
      SlideRed: false,
      Pond: false,
      Sandbox: false,
      KitePurple: false,
      KitePink: false,
      TireSwing: false,
      SpringToy: false,
      Ball: false,
      Flowers: false,
      Swingset: false,
      MerryGoRound: false,
      ButterflyPink: false,
      ButterflyBlue: false,
      Bow: false,
      Hat: false,
    },
    unlockedDays: {
      day1: false,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
      day9: false,
      day10: false,
    },
  },
};

const Module2Reducer = (state = module2InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE2_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed !== null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed!== null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        MonkeybarsBlue: false,
        MonkeybarsYellow: false,
        SlideYellow: false,
        SlideRed: false,
        Pond: false,
        Sandbox: false,
        KitePurple: false,
        KitePink: false,
        TireSwing: false,
        SpringToy: false,
        Ball: false,
        Flowers: false,
        Swingset: false,
        MerryGoRound: false,
        ButterflyPink: false,
        ButterflyBlue: false,
        Bow: false,
        Hat: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj !== 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[]}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day4: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
        day9: false,
        day10: false,
      };
      if (action.payload?.day_completed !== null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module2: {
          ...state.module2,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
        },
      };
    }
    case 'CLEAR': {
      return {
        ...module2InitialState,
      };
    }
    case 'MODULE2_SET_DAY': {
      return {
        ...state,
        module2: {
          ...state.module2,
          currentday: action.payload,
        },
      };
    }

    case 'MODULE2_SET_GameDetails': {
      return {
        ...state,
        module2: {
          ...state.module2,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE2_SET_stepCompleted': {
      return {
        ...state,
        module2: {
          ...state.module2,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE2_SET_dayCompleted': {
      return {
        ...state,
        module2: {
          ...state.module2,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE2_SET_CAMERAOPEN': {
      return {
        ...state,
        module2: {
          ...state.module2,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE2_SET_KEY': {
      return {
        ...state,
        module2: {
          ...state.module2,
          keys: action.payload,
        },
      };
    }
    case 'MODULE2_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module2: {
          ...state.module2,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE2_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module2: {
          ...state.module2,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE2_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module2: {
          ...state.module2,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE2_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module2: {
          ...state.module2,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE2_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module2: {
          ...state.module2,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE2_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module2: {
          ...state.module2,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE2_SET_REWARD11': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            MonkeybarsBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD12': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            MonkeybarsYellow: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD21': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            SlideRed: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD22': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            SlideYellow: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD31': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Pond: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD32': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Sandbox: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD41': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            KitePurple: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD42': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            KitePink: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD51': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            TireSwing: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD52': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            SpringToy: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD61': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Ball: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD62': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Flowers: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD71': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Swingset: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD72': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            MerryGoRound: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD81': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            ButterflyPink: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD82': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            ButterflyBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD91': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Bow: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_REWARD92': {
      return {
        ...state,
        module2: {
          ...state.module2,
          rewards: {
            ...state.module2.rewards,
            Hat: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK9': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day9: action.payload,
          },
        },
      };
    }
    case 'MODULE2_SET_DAY_UNLOCK10': {
      return {
        ...state,
        module2: {
          ...state.module2,
          unlockedDays: {
            ...state.module2.unlockedDays,
            day10: action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
};
export default Module2Reducer;
